<template>
    <el-table :data="tableData" border style="width: 100%">
        <el-table-column
            label="序号"
            align="center"
            width="50"
            type="index"
        ></el-table-column>
        <el-table-column
            v-for="(item, index) in data.columnList"
            :key="index"
            :label="item.label"
            :width="item.width"
            :prop="item.prop"
            align="center"
        >
            <template #default="scope" v-if="item.prop === 'userType'">
                {{ userTypeInfo[scope.row.userType] || "" }}
            </template>
            <template #default="scope" v-else-if="item.prop === 'paymentMethod'">
                {{ scope.row.paymentMethod == 1 ? "充值" : "消费" }}
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
            <template #default="scope">
                <el-button
                    type="primary"
                    size="mini"
                    @click="handleAudit(scope.row)"
                >退款</el-button
                >
            </template>
        </el-table-column>
    </el-table>
    <!-- 审核 -->
    <audit-user ref="AuditUserRef" :currentData="data.currentData"></audit-user>
    <!-- 修改 用户信息 -->
    <add-edit-user
        ref="AddEditUserRef"
        scene="edit"
        :currentData="data.currentData"
    ></add-edit-user>
</template>

<script>
import { reactive } from "@vue/reactivity";
import { inject, ref } from "vue";
import AuditUser from "./children/audit-user.vue";
import AddEditUser from "./children/add-edit-user.vue";
export default {
    props: {
        tableData: Array,
    },
    components: {
        AuditUser,
        AddEditUser,
    },
    setup() {
        const userTypeInfo = inject("userTypeInfo");
        const AddEditUserRef = ref(null);
        const AuditUserRef = ref(null);
        const data = reactive({
            currentData: {},
            columnList: [
                {
                    label: "消费订单号",
                    prop: "transactionId",
                },
                {
                    label: "姓名",
                    prop: "userName",
                    width: 80
                },
                {
                    label: "手机号",
                    prop: "phone",
                    width: 110
                },
                {
                    label: "类型",
                    prop: "paymentMethod",
                    width: 80
                },
                {
                    label: "描述",
                    prop: "description",
                },
                {
                    label: "充值时间",
                    prop: "consumptionTime",
                },
                {
                    label: "总金额",
                    prop: "amount",
                    width: 80
                },
                {
                    label: "赠送金额",
                    prop: "giftAmount",
                    width: 100
                },
                {
                    label: "已退款金额",
                    prop: "tkAmount",
                    width: 100
                }
            ],
        });

        const handleEdit = (val) => {
            data.currentData = val;
            AddEditUserRef.value.handleToggle(true);
        };
        const handleAudit = (val) => {
            console.log(val)
            data.currentData = val;
            AuditUserRef.value.handleToggle(true);
        };
        return {
            AddEditUserRef,
            AuditUserRef,
            handleAudit,
            handleEdit,
            data,
            userTypeInfo,
        };
    },
};
</script>

<style  scoped>
</style>
